<template>
  <div id="dailog" :style="{left:left+'px',top:top+'px'}">
    <div class="dailog-box" v-if="show" :style="{width:width+'px'}">
      <div class="dailog-top" @mousedown.self="dragMoveWindow">
        <h2 class="title">{{title}}</h2>
        <i class="iconfont icon-close" @click="close"></i>
      </div>
      <div class="content">
        <slot></slot>
      </div>
      <div class="button-box" v-if="button">
        <span class="cancle" @click="close">取消</span>
        <span class="add" @click="add">{{buttonName}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'dailog',
  components:{

  },
  data(){
    return {
      left:240,
      top:240,
    }
  },
  props:{
    width:{
      type:Number,
      default: 800
    },
    title:{
      type:String,
      default:''
    },
    show:{
      type:Boolean,
      default:false
    },
    button:{
      type:Boolean,
      default:true
    },
    drag:{
      type:Boolean,
      default:true
    },
    buttonName:{
      type:String,
      default:'添加'
    }
  },
  created(){

  },
  mounted(){
  },
  methods:{
    close() {
      this.$emit('close',this.$props.show);
    },
    //拖拽移动窗口
    dragMoveWindow(e) {
      if(this.$props.drag) {
        let offsetLeft = e.srcElement.parentElement.parentElement.offsetLeft;
        let offsetTop = e.srcElement.parentElement.parentElement.offsetTop;
        let clientX  = e.clientX;
        let clientY = e.clientY;
        let targetLeft = clientX - offsetLeft;
        let targetTop = clientY - offsetTop;
        document.onmousemove = (e)=>{
          let finalLeft = e.clientX - targetLeft;
          let finalTop = e.clientY - targetTop;
          this.left = finalLeft+'px';
          this.top =  finalTop+'px';
        }
        document.onmouseup = (e)=>{
          document.onmousemove = null;
          document.onmouseup  = null;
        }
      }
    },
    //添加
    add() {
      this.$emit('add',null);
    }
  },
  computed:{

  },
  beforeDestroy(){

  }
}
</script>
<style scoped>
  #dailog {
    width: fit-content;
    min-height: 620px;
    max-height: 1000px;
    overflow: auto;
  }

  .dailog-box {
    min-height: 220px;
    max-height: 1000px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
    background-color: #fff;
  }

  .dailog-top {
    width: 100%;
    height: 40px;
    display: flex;
    background-color: #4476A7;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    cursor: move;
  }

 .title {
    width: fit-content;
    height: 100%;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: rgba(255,255,255,.8);
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
  }

  .dailog-top .icon-close {
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: medium;
    font-weight: lighter;
    cursor: pointer;
  }

  /* 弹窗内容 */
 .content {
    flex: 1;
    width: 100%;
  }

  /* 按钮组 */
  .button-box {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .button-box span {
    width: 60px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 20px;
    cursor: pointer;
    font-size: medium;
    border-radius: 4px;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
  }

  .cancle {
    border: 1px solid #bcbcbc;
  }

  .cancle:hover {
    border: 1px solid green;
  }

  .add {
    background-color: #1E9FFF;
    color:#fff;
  }
</style>